import { apiPaginatedClient } from '@/lib/api/api-client'
import type { SearchableLocation } from '@/features/jobs/types/searchable-location'

export const apiGetJobLocations = (query?: string, page = 1) => {
  const params = new URLSearchParams()
  const trimmed = query?.trim()

  if (trimmed) {
    params.set('query', trimmed)
  }

  params.set('page', String(page))

  return apiPaginatedClient<SearchableLocation[]>(
    `/api/v1/jobs/locations?${params.toString()}`
  )
}
